/**
 * Pure route constants and URL builders for the reporting / insights section.
 *
 * Kept free of React and page-config imports so the route resolver and its tests
 * can depend on it without pulling in the whole feature. `pages.ts` re-exports
 * these for backwards compatibility.
 *
 * `/insights` is the canonical Custom Dashboards home. The legacy `/reporting`
 * namespace is retained to forward old bookmarks/deep links to `/insights`
 * (see `resolveInsightsRoute`) and to host the standalone `DATA_DESTINATIONS_PATH` page.
 */
export const REPORTING_PATH = '/reporting'
export const INSIGHTS_PATH = '/insights'

/** Standalone cloud delivery destinations management page (namespace-independent). */
export const DATA_DESTINATIONS_PATH = `${REPORTING_PATH}/data-destinations`

export const MY_REPORTS_PAGE_ID = 'mine'
export const CUSTOM_DASHBOARDS_PAGE_ID = 'custom-dashboards'

/** Canonical Insights home + Custom Dashboards deep links. */
export const insightsHref = `${INSIGHTS_PATH}/${CUSTOM_DASHBOARDS_PAGE_ID}`
export const customDashboardsHref = insightsHref
export const customDashboardsMyReportsHref = `${insightsHref}/${MY_REPORTS_PAGE_ID}`

export const dashboardUrl = (dashboardId: string) => `${insightsHref}/dashboard/${dashboardId}`
export const widgetUrl = (dashboardId: string, widgetId: string) => `${dashboardUrl(dashboardId)}/widget/${widgetId}`
export const newWidgetUrl = (dashboardId: string) => widgetUrl(dashboardId, 'new')
